export const PACKAGING_TYPE_RESET_STATE = 'PACKAGING_TYPE_RESET_STATE';
export const PACKAGING_TYPE_CURRENT_ITEM = 'PACKAGING_TYPE_CURRENT_ITEM';

export const PACKAGING_TYPE_REQUEST_LOADING = 'PACKAGING_TYPE_REQUEST_LOADING';
export const PACKAGING_TYPE_REQUEST_SUCCESS = 'PACKAGING_TYPE_REQUEST_SUCCESS';
export const PACKAGING_TYPE_REQUEST_FAILED = 'PACKAGING_TYPE_REQUEST_FAILED';

export const PACKAGING_TYPE_CURRENT_ACTION = 'PACKAGING_TYPE_CURRENT_ACTION';
export const PACKAGING_TYPE_RESET_ACTION = 'PACKAGING_TYPE_RESET_ACTION';